module.exports = __webpack_public_path__ + "static/media/StatsInactive.41b8414d.svg";